module.exports = __webpack_public_path__ + "static/media/za.f3dde29c.svg";